export const SIGNAL_RECORD_BET_CLICK = 'signal/SIGNAL_RECORD_BET_CLICK';
export const SIGNAL_RECORD_ENTER_ROUND = 'signal/SIGNAL_RECORD_ENTER_ROUND';
export const SIGNAL_RECORD_LOGIN = 'signal/SIGNAL_RECORD_LOGIN';
export const SIGNAL_RECORD_PAGE_LOAD = 'signal/SIGNAL_RECORD_PAGE_LOAD';
